export default "/assets/images/the-basic-breather.53c8dd89896551ee.webp";